const API_BASE_URL = '/api'; // Using Vite proxy

const getAuthToken = () => localStorage.getItem('authToken');

// --- Auth ---
export const login = async (email: string, password_hash: string) => {
  const response = await fetch(`${API_BASE_URL}/auth/login`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ email, password_hash }),
  });
  if (!response.ok) {
    throw new Error('Login failed');
  }
  return response.json();
};


// --- Models ---
export const getModels = async () => {
  const response = await fetch(`${API_BASE_URL}/models`);
  if (!response.ok) {
    throw new Error('Failed to fetch models');
  }
  return response.json();
};

export const getModel = async (id: number) => {
    const response = await fetch(`${API_BASE_URL}/models/${id}`);
    if (!response.ok) {
      throw new Error('Failed to fetch model');
    }
    return response.json();
  };

// --- User State ---
export const getUserState = async (userId: number) => {
  const token = getAuthToken();
  const response = await fetch(`${API_BASE_URL}/state/${userId}`, {
    headers: { 'Authorization': `Bearer ${token}` }
  });
  if (!response.ok) {
    throw new Error('Failed to get user state');
  }
  return response.json();
};

export const saveUserState = async (userId: number, state: any) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/save-state`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ userId, state }),
    });
    if (!response.ok) {
        throw new Error('Failed to save user state');
    }
    return response.json();
};

// --- Purchase ---
export const purchaseModel = async (userId: number, modelId: number, paymentToken: string) => {
    const token = getAuthToken();
    const response = await fetch(`${API_BASE_URL}/purchase`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({ userId, modelId, paymentToken }),
    });
    if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.message || 'Purchase failed');
    }
    return response.json();
};
